import { CLOSE_WINDOW_TYPES } from "./closeWindow";
import { injectable, inject } from "inversify";
import SI from "../constants/identifiers";
import SystemPlatform from "./SystemPlatform";
import InitResult from "../connect/result/InitResult";
import Settings from "../settings/Settings";
import AddResult from "../connect/result/AddResult";
import Wallet from "../wallet/Wallet";

export const MODES = {
	FREE: "free",
	REAL: "real",
	REPLAY: "replay",
};

export const CONFIG_PARAMS = {
	SERVER_API: "server_api",
	QUALITY: "quality",
	CASINO_ID: "casino_id",
	PLAYER_ID: "player_id",
	GAME_ID: "game_id",
	SESSION_KEY: "session_key",
	SESSION_ID: "session_id",
	MODE: "mode",
	LANGUAGE: "language",
	CURRENCY: "currency",
	COINS: "coins",
	MUTE: "mute",
	DEF_LANG: "def_lang",
	HOME_URL: "home",
	ON_HOME: "on_home", //on home action
	HOME_URL_ENCODED: 'url_encoded', // if true, HOME_URL is encoded in base64
	HOME_SETTINGS: "home_settings",
	BACK_URL: "backurl",
	DEBUG: "debug",
	REGULATION: "reg",
	LEGISLATION: "legislation",
	KEY_BINDINGS: "key_bindings",

	BRAND_NAME: "brand_name",

	PLAYTECH_SKIN: "skin",
	PLAYTECH_CHANNEL_TYPE: "channeltype",
	PLAYTECH_CLIENT_TYPE: "clienttype",
	PLAYTECH_ACCOUNT_ID: "account_id",
	PLAYTECH_CLIENT_PLATFORM: "clientplatform",

	DISABLE_FULLSCREEN: "disable_fullscreen",
	DISABLE_IOS_SWIPER: "disable_ios_swiper",
	DISABLE_SWIPER: "disable_swiper",
	SWIPER: "swiper",

	START_MATRIX: "start_matrix",
	START_SYMBOLS_POSITION: "start_symbols_position",
	SYMBOL_DEFINITION: "symbolDefinition",
	GAME_SPECIFICS: "gameSpecifics",
	FS_GAME_SPECIFICS: "FSGameSpecifics",
	REELS: "reels",
	WIN_LINES: "winLines",
	FORCESTOP_ENABLED: "forcstopEnabled",

	BIG_WIN_FACTOR: "minBigWinFactor",
	MEGA_WIN_FACTOR: "minMegaWinFactor",
	SUPER_WIN_FACTOR: "minSuperMegaWinFactor",
	BEHAVIOR_PATTERN: "behavior_pattern",
	BEHAVIOR: "behavior",
	AUTOSTART: "autostart",

	DISABLE_AUTOSTART: "disable_autostart",
	MAX_BET_WARNING: 'max_bet_warning',
	MAX_BET_WARNING_TIMEOUT: 'max_bet_warning_timeout',

	TIMEOUTS: "timeouts",
	URL_CDN: "urlCdn",
	URL_SETTINGS: "urlSettings",
	URL_INIT: "urlInit",
	URL_INIT_METHOD: "urlInitMethod",
	URL_ADD: "urlAdd",
	URL_ADD_METHOD: "urlAddMethod",
	URL_UPDATE: "urlUpdate",
	URL_UPDATE_METHOD: "urlUpdateMethod",
	URL_CLOSE: "urlClose",
	URL_CLOSE_METHOD: "urlCloseMethod",
	URL_REGULATION: "urlRegulation",
	URL_REGULATION_METHOD: "urlRegulationMethod",
	URL_BALANCE: "urlBalance",
	URL_BALANCE_METHOD: "urlBalanceMethod",
	URL_WEBSOCKET: "urlWebsocket",
	URL_HISTORY_PARAM: "history", //synot
	URL_IGT_HISTORY: 'historyurl',
	URL_GET_GAME_OPT: "urlGetGameOpt",
	URL_GET_GAME_OPT_METHOD: "urlGetGameOptMethod",
	URL_SET_GAME_OPT: "urlSetGameOpt",
	URL_SET_GAME_OPT_METHOD: "urlSetGameOptMethod",
	URL_GET_DEVICE_OPT: "urlGetDeviceOpt",
	URL_GET_DEVICE_OPT_METHOD: "urlGetDeviceOptMethod",
	URL_SET_DEVICE_OPT: "urlSetDeviceOpt",
	URL_SET_DEVICE_OPT_METHOD: "urlSetDeviceOptMethod",
	URL_GET_LAST_OPTS: "urlGetLastOpts",
	URL_GET_LAST_OPTS_METHOD: "urlGetLastOptsMethod",
	URL_GET_BUTTON_OPTS: "urlGetButtonOpts",
	URL_GET_BUTTON_OPT_METHOD: "urlGetButtonOptsMethod",
	URL_SET_BUTTON_OPTS: "urlSetButtonOpts",
	URL_SET_BUTTON_OPT_METHOD: "urlSetButtonOptsMethod",
	URL_REPLAY: "urlReplay",
	URL_REPLAY_METHOD: "urlReplayMethod",
	URL_REPLAY_SESSION: "urlReplaySession",
	URL_REPLAY_SESSION_METHOD: "urlReplaySessionMethod",
	URL_REPLAY_ROUND: "urlReplayRound",
	URL_REPLAY_ROUND_METHOD: "urlReplayRoundMethod",
	URL_LOGIC: "urlLogic",
	URL_LOGIC_METHOD: "urlLogicMethod",
	URL_PLATFORM_SETTINGS: "urlPlatformSettings",
	URL_PLATFORM_SETTINGS_METHOD: "urlPlatformSettingsMethod",
	URL_JOKER_BONUS_WIN: "urlJokerBonusWin",
	URL_JOKER_BONUS_WIN_Method: "urlJokerBonusWinMethod",
	URL_JOKER_BONUS_DISPLAY: "urlJokerBonusDisplay",
	URL_JOKER_BONUS_DISPLAY_METHOD: "urlJokerBonusDisplayMethod",
	URL_JOKER_BONUS_THEMES: "urlJokerBonusThemes",
	URL_JOKER_BONUS_THEMES_METHOD: "urlJokerBonusThemesMethod",
	URL_JOKER_BONUS_OPEN_TICKETS: "urlJokerBonusOpenTickets",
	URL_JOKER_BONUS_OPEN_TICKETS_METHOD: "urlJokerBonusOpenTicketsMethod",
	URL_JOKER_BONUS_LEVEL_INFO: "urlJokerBonusLevelInfo",
	URL_JOKER_BONUS_CURRENCY_CONVERT: "urlJokerBonusCurrencyConvert",
	URL_JOKER_BONUS_CURRENCY_CONVERT_METHOD: "urlJokerBonusCurrencyConvertMethod",

	URL_GET_SESSIONS: "urlGetSessions",
	URL_GET_SESSIONS_METHOD: "urlGetSessionsMethod",
	URL_GET_GAME_SESSIONS: "urlGetGameSessions",
	URL_GET_GAME_SESSIONS_METHOD: "urlGetGameSessionsMethod",

	WEB_SOCKET: "websocket",

	FAIL_RESULT: "failResult",

	RENDER: "render",

	SEPARATED_INFOPAGES: "separated_infopages",

	EXHIBITION: "exhibition",
	DISPLAYS: "displays",
	NOCORS: "nocors",
	PLATFORM: "platform",
	POST_MESSAGES: "post_messages",

	IS_HISTORY: "isHistory",
	IS_PARAGRAPH: "isParagraph",
	WARNING_MESSAGE: "warning_message",
	FULLSCREEN: "full_screen",
	RESPONSIBLE_GAMING: "responsible_gaming",
	PLAYER_OPTIONS: "player_options",

	MATH_VERSION: "math_version",
	BG_COLOR: "bgcolor",
	UI_MODE: "ui_mode", // allowed ui types, taken from settings.ui_mode
	// mobile if any MobileUI is used
	// desktop if any DesktopUI is used
	UI_DEVICE: "ui_device",

	INTERNAL: "internal",
	REPLAY_RESULT: "replay_result",
	REPLAY_UI: "replay_ui",
	REPLAY_ROUND: "replay_round",
	REPLAY_SESSION: "replay_session",

	ONLY_COINS: "only_coins",

	JOKER_BONUS: "jokerbonus",
	JOKER_BONUS_MODE: "jokerbonus_mode",
	JOKER_BONUS_POPUP: "jokerbonus_mode_popup",
	RTP: "rtp",
	MAX_ALLOWED_BET_URL: "max_allowed_bet",

	APP_BUTTONS: "app_buttons",
	BG_IMG: "bgimage",
	USE_WS_BALANCE: "game_use_ws_balance",
	USE_FS_TOTAL_WIN:"use_fs_total_win",
	INTEGRATION:'integration'
};

export const GAMECONF_PARAMS = {
	ALLOW_HISTORY: "allowHistory",
	ALLOW_PARAGRAPH: "allowParagraph",
	CONNECT_TIMEOUT: "connect_timeout",
	MV: "mv",
};

@injectable()
export default class SystemConfig {
	public gameset: any;
	public gameconf: any = {};
	public platform: SystemPlatform;
	useLangURL: boolean = false;

	private serverConfig: any;
	private config: any;
	private urlConfig: any;

	constructor(
		@inject(SI.Gameset) gameset: any,
		@inject(SI.SystemPlatform) platform: SystemPlatform
	) {
		this.gameset = gameset;
		this.platform = platform;
		this.initGameConf();

		this.serverConfig = (<any>window)["ServerConfig"];

		this.config = {
			[CONFIG_PARAMS.SERVER_API]: 1,
			[CONFIG_PARAMS.GAME_ID]: this.gameset.game_id,
			// [CONFIG_PARAMS.AUDIO_MUTE]: false,
			[CONFIG_PARAMS.DEF_LANG]: "en",
		};

		this.urlConfig = {
			[CONFIG_PARAMS.CURRENCY]: "EUR",
			[CONFIG_PARAMS.QUALITY]: "h",
			[CONFIG_PARAMS.CASINO_ID]: 0,
			[CONFIG_PARAMS.PLAYER_ID]: null,
			[CONFIG_PARAMS.SESSION_KEY]: null,
			[CONFIG_PARAMS.MODE]: "free",
			[CONFIG_PARAMS.LANGUAGE]: this.config[CONFIG_PARAMS.DEF_LANG],
			[CONFIG_PARAMS.HOME_URL]: "../",
			[CONFIG_PARAMS.URL_HISTORY_PARAM]: null,
			[CONFIG_PARAMS.URL_IGT_HISTORY]: null,
			[CONFIG_PARAMS.ON_HOME]: CLOSE_WINDOW_TYPES.HOME,
			[CONFIG_PARAMS.BACK_URL]: null,
			[CONFIG_PARAMS.DEBUG]: false,
			[CONFIG_PARAMS.REGULATION]: null,
			[CONFIG_PARAMS.RENDER]: null,
			[CONFIG_PARAMS.DISABLE_FULLSCREEN]: false,
			[CONFIG_PARAMS.DISABLE_IOS_SWIPER]: null,
			[CONFIG_PARAMS.DISABLE_SWIPER]: null,
			[CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM]: null,
			[CONFIG_PARAMS.PLAYTECH_SKIN]: null,
			[CONFIG_PARAMS.PLAYTECH_CHANNEL_TYPE]: null,
			[CONFIG_PARAMS.PLAYTECH_CLIENT_TYPE]: null,
			[CONFIG_PARAMS.PLAYTECH_ACCOUNT_ID]: null,
			[CONFIG_PARAMS.MUTE]: false,
			[CONFIG_PARAMS.EXHIBITION]: null,
			[CONFIG_PARAMS.NOCORS]: false,
			[CONFIG_PARAMS.DISPLAYS]: 1,
			[CONFIG_PARAMS.BG_COLOR]: null,
			[CONFIG_PARAMS.BG_IMG]: null,
			[CONFIG_PARAMS.SWIPER]: null,
			[CONFIG_PARAMS.INTERNAL]: null,
			[CONFIG_PARAMS.REPLAY_UI]: null,
			[CONFIG_PARAMS.REPLAY_ROUND]: null,
			[CONFIG_PARAMS.REPLAY_SESSION]: null,
			[CONFIG_PARAMS.ONLY_COINS]: 0,
			[CONFIG_PARAMS.JOKER_BONUS]: false,
			[CONFIG_PARAMS.MAX_ALLOWED_BET_URL]: null,
			[CONFIG_PARAMS.HOME_URL_ENCODED]: null,
			[CONFIG_PARAMS.INTEGRATION]:null
		};

		this.init();
	}

	private init() {
		let url = new URL(window.location.href);
		url.searchParams.forEach((val: any, key) => {
			// val = this.parseIntParam(CONFIG_PARAMS.CASINO_ID, key, val);
			//val = this.parseIntParam(CONFIG_PARAMS.PLAYER_ID, key, val);
			val = this.parseIntParam(CONFIG_PARAMS.DISPLAYS, key, val);

			if (key === CONFIG_PARAMS.RENDER) {
				if (val == "canvas" || val == "c") {
					val = "CANVAS";
				} else if (val == "webgl" || val == "gl") {
					val = "WEBGL";
				} else {
					val = null;
				}
			}

			if (typeof this.urlConfig[key] !== "undefined") {
				if (key === CONFIG_PARAMS.LANGUAGE) this.useLangURL = true;
				this.urlConfig[key] = val;
			}
		});

		this.config[CONFIG_PARAMS.URL_SETTINGS] =
			this.serverConfig.getSettingsUrl();
		this.config[CONFIG_PARAMS.URL_INIT] = this.serverConfig.getInitUrl();
		this.config[CONFIG_PARAMS.URL_ADD] = this.serverConfig.getAddUrl();
		this.config[CONFIG_PARAMS.URL_UPDATE] = this.serverConfig.getUpdateUrl();
		this.config[CONFIG_PARAMS.URL_CLOSE] = this.serverConfig.getCloseUrl();
		this.config[CONFIG_PARAMS.URL_REGULATION] =
			this.serverConfig.getRegulationURL();
		this.config[CONFIG_PARAMS.URL_BALANCE] = this.serverConfig.getBalanceUrl
			? this.serverConfig.getBalanceUrl()
			: null;
		this.config[CONFIG_PARAMS.URL_WEBSOCKET] = this.serverConfig.getWebsocketUrl
			? this.serverConfig.getWebsocketUrl()
			: null;

		this.config[CONFIG_PARAMS.FORCESTOP_ENABLED] = true;

		this.config[CONFIG_PARAMS.SEPARATED_INFOPAGES] =
			this.gameset.infoPages && this.gameset.infoPages.separated;

		this.config = { ...this.config, ...this.urlConfig };

		if (this.config[CONFIG_PARAMS.HOME_URL_ENCODED] === "True") {
			this.config[CONFIG_PARAMS.HOME_URL] = window.atob(this.config[CONFIG_PARAMS.HOME_URL])
		}
		this.config[CONFIG_PARAMS.HOME_URL] = decodeUrl(
			this.config[CONFIG_PARAMS.HOME_URL]
		)

		this.config[CONFIG_PARAMS.URL_HISTORY_PARAM] = decodeUrl(
			this.config[CONFIG_PARAMS.URL_HISTORY_PARAM]
		);
		this.config[CONFIG_PARAMS.URL_IGT_HISTORY] = decodeUrl(
			this.config[CONFIG_PARAMS.URL_IGT_HISTORY]
		);
		this.config[CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM] = decodeUrl(
			this.config[CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM]
		);

		if (this.config[CONFIG_PARAMS.LANGUAGE].toLowerCase() === "cz")
			this.config[CONFIG_PARAMS.LANGUAGE] = "cs";

		this.config[CONFIG_PARAMS.LANGUAGE] =
			this.config[CONFIG_PARAMS.LANGUAGE].toLowerCase();
		this.config[CONFIG_PARAMS.CURRENCY] =
			this.config[CONFIG_PARAMS.CURRENCY].toUpperCase();
		this.config[CONFIG_PARAMS.CASINO_ID] = Number(
			this.config[CONFIG_PARAMS.CASINO_ID]
		);

		this.platform.init(this);
	}

	public initSettings(settings: Settings) {
		this.set(CONFIG_PARAMS.USE_FS_TOTAL_WIN, settings.getUseFSTotalWin())
		this.set(CONFIG_PARAMS.BIG_WIN_FACTOR, settings.getMinBigWinFactor());
		this.set(CONFIG_PARAMS.MEGA_WIN_FACTOR, settings.getMinMegaWinFactor());
		this.set(
			CONFIG_PARAMS.SUPER_WIN_FACTOR,
			settings.getMinSuperMegaWinFactor()
		);
		this.set(CONFIG_PARAMS.COINS, settings.getCoins());
		this.set(CONFIG_PARAMS.FORCESTOP_ENABLED, settings.isForcestopEnabled());
		this.set(CONFIG_PARAMS.BEHAVIOR_PATTERN, settings.getBehaviorPattern());
		this.set(CONFIG_PARAMS.BEHAVIOR, settings.getBehavior());
		this.set(CONFIG_PARAMS.KEY_BINDINGS, settings.getKeyBindings());
		this.set(CONFIG_PARAMS.BRAND_NAME, settings.getBrandName());

		this.set(CONFIG_PARAMS.TIMEOUTS, settings.getTimeouts());
		this.set(CONFIG_PARAMS.IS_HISTORY, settings.getHistory());
		this.set(CONFIG_PARAMS.IS_PARAGRAPH, settings.getParagraph());
		this.set(CONFIG_PARAMS.WARNING_MESSAGE, settings.getWarningMessage());
		this.set(CONFIG_PARAMS.FULLSCREEN, settings.getFullScreen());
		this.set(CONFIG_PARAMS.RESPONSIBLE_GAMING, settings.getResponsibleGaming());
		this.set(CONFIG_PARAMS.PLAYER_OPTIONS, settings.getPlayerOptions());
		this.set(CONFIG_PARAMS.AUTOSTART, settings.getAutoStart());
		this.set(CONFIG_PARAMS.URL_CDN, settings.getCDN());
		this.set(CONFIG_PARAMS.PLATFORM, settings.getPlatform());
		this.set(CONFIG_PARAMS.HOME_SETTINGS, settings.getHomeSettings());
		this.set(CONFIG_PARAMS.POST_MESSAGES, settings.getPostMessages());

		this.set(CONFIG_PARAMS.JOKER_BONUS, settings.getJokerBonus());
		this.set(CONFIG_PARAMS.JOKER_BONUS_MODE, settings.getJokerBonusMode());
		this.set(CONFIG_PARAMS.JOKER_BONUS_POPUP, settings.getJokerBonusPopup());

		this.set(CONFIG_PARAMS.UI_MODE, settings.getUIMode());

		if (settings.getLegislation()) {
			this.set(
				CONFIG_PARAMS.LEGISLATION,
				settings.getLegislation().toLowerCase()
			);
		}
		this.set(CONFIG_PARAMS.DISABLE_AUTOSTART, settings.getDisableAutostart());
		this.set(CONFIG_PARAMS.MAX_BET_WARNING, Number(settings.getMaxBetWarning()?.level) || 0)
		this.set(CONFIG_PARAMS.MAX_BET_WARNING_TIMEOUT, Number(settings.getMaxBetWarning()?.timeout) || 3000)
		this.set(CONFIG_PARAMS.RTP, settings.getRtp());
		this.set(CONFIG_PARAMS.APP_BUTTONS, settings.getAppsButtons());
		this.set(CONFIG_PARAMS.USE_WS_BALANCE, settings.getUseWSBalance() ?? true);

		let actions = settings.getActions();
		// Set action urls if set, else use the ones from config.js
		actions?.init?.url && this.set(CONFIG_PARAMS.URL_INIT, actions?.init?.url);
		actions?.regulation?.url &&
			this.set(CONFIG_PARAMS.URL_REGULATION, actions?.regulation?.url);
		actions?.add?.url && this.set(CONFIG_PARAMS.URL_ADD, actions?.add?.url);
		actions?.update?.url &&
			this.set(CONFIG_PARAMS.URL_UPDATE, actions?.update?.url);
		actions?.balance?.url &&
			this.set(CONFIG_PARAMS.URL_BALANCE, actions?.balance?.url);
		actions?.close?.url &&
			this.set(CONFIG_PARAMS.URL_CLOSE, actions?.close?.url);
		actions?.game_settings?.url &&
			this.set(CONFIG_PARAMS.URL_GET_GAME_OPT, actions?.game_settings?.url);
		actions?.update_game_settings?.url &&
			this.set(
				CONFIG_PARAMS.URL_SET_GAME_OPT,
				actions?.update_game_settings?.url
			);
		actions?.device_settings?.url &&
			this.set(CONFIG_PARAMS.URL_GET_DEVICE_OPT, actions?.device_settings?.url);
		actions?.update_device_settings?.url &&
			this.set(
				CONFIG_PARAMS.URL_SET_DEVICE_OPT,
				actions?.update_device_settings?.url
			);
		actions?.button_settings?.url &&
			this.set(
				CONFIG_PARAMS.URL_GET_BUTTON_OPTS,
				actions?.button_settings?.url
			);
		actions?.update_button_settings?.url &&
			this.set(
				CONFIG_PARAMS.URL_SET_BUTTON_OPTS,
				actions?.update_button_settings?.url
			);
		actions?.last_settings?.url &&
			this.set(CONFIG_PARAMS.URL_GET_LAST_OPTS, actions?.last_settings?.url);
		actions?.replay?.url &&
			this.set(CONFIG_PARAMS.URL_REPLAY, actions?.replay?.url);
		actions?.replay_session?.url &&
			this.set(CONFIG_PARAMS.URL_REPLAY_SESSION, actions?.replay_session?.url);
		actions?.replay_round?.url &&
			this.set(CONFIG_PARAMS.URL_REPLAY_ROUND, actions?.replay_round?.url);
		actions?.logic?.url &&
			this.set(CONFIG_PARAMS.URL_LOGIC, actions?.logic?.url);
		actions?.platform_settings?.url &&
			this.set(
				CONFIG_PARAMS.URL_PLATFORM_SETTINGS,
				actions?.platform_settings?.url
			);

		actions?.open_sessions?.url &&
			this.set(CONFIG_PARAMS.URL_GET_SESSIONS, actions?.open_sessions?.url);
		actions?.open_game_sessions?.url &&
			this.set(
				CONFIG_PARAMS.URL_GET_GAME_SESSIONS,
				actions?.open_game_sessions?.url
			);
		actions?.joker_bonus_win?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_WIN,
				actions?.joker_bonus_win?.url
			);
		actions?.joker_bonus_display_converted?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_DISPLAY,
				actions?.joker_bonus_display_converted?.url
			);

		actions?.joker_bonus_group_theme?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_THEMES,
				actions?.joker_bonus_group_theme?.url
			);

		actions?.list_joker_bonus_open_tickets_v2?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_OPEN_TICKETS,
				actions?.list_joker_bonus_open_tickets_v2?.url
			);
		actions?.joker_bonus_level_dashboard?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_LEVEL_INFO,
				actions?.joker_bonus_level_dashboard?.url
			);
		actions?.joker_bonus_converted?.url &&
			this.set(
				CONFIG_PARAMS.URL_JOKER_BONUS_CURRENCY_CONVERT,
				actions?.joker_bonus_converted?.url
			);
		// Set action method if set, else method post is used
		this.set(CONFIG_PARAMS.URL_INIT_METHOD, actions?.init?.method ?? "post");
		this.set(
			CONFIG_PARAMS.URL_REGULATION_METHOD,
			actions?.regulation?.method ?? "post"
		);
		this.set(CONFIG_PARAMS.URL_ADD_METHOD, actions?.add?.method ?? "post");
		this.set(
			CONFIG_PARAMS.URL_UPDATE_METHOD,
			actions?.update?.method ?? "post"
		);
		this.set(
			CONFIG_PARAMS.URL_BALANCE_METHOD,
			actions?.balance?.method ?? "post"
		);
		this.set(CONFIG_PARAMS.URL_CLOSE_METHOD, actions?.close?.method ?? "post");
		this.set(
			CONFIG_PARAMS.URL_GET_GAME_OPT_METHOD,
			actions?.game_settings?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_SET_GAME_OPT_METHOD,
			actions?.update_game_settings?.method ?? "patch"
		);
		this.set(
			CONFIG_PARAMS.URL_GET_DEVICE_OPT_METHOD,
			actions?.device_settings?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_SET_DEVICE_OPT_METHOD,
			actions?.update_device_settings?.method ?? "patch"
		);
		this.set(
			CONFIG_PARAMS.URL_GET_BUTTON_OPT_METHOD,
			actions?.button_settings?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_SET_BUTTON_OPT_METHOD,
			actions?.update_button_settings?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_GET_LAST_OPTS_METHOD,
			actions?.last_settings?.method ?? "get"
		);
		this.set(CONFIG_PARAMS.URL_REPLAY_METHOD, actions?.replay?.method ?? "get");
		this.set(
			CONFIG_PARAMS.URL_REPLAY_SESSION_METHOD,
			actions?.replay_session?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_REPLAY_ROUND_METHOD,
			actions?.replay_round?.method ?? "get"
		);
		this.set(CONFIG_PARAMS.URL_LOGIC_METHOD, actions?.logic?.method ?? "get");
		this.set(
			CONFIG_PARAMS.URL_PLATFORM_SETTINGS_METHOD,
			actions?.platform_settings?.method ?? "get"
		);

		this.set(
			CONFIG_PARAMS.URL_GET_SESSIONS_METHOD,
			actions?.open_sessions?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_GET_GAME_SESSIONS_METHOD,
			actions?.open_game_sessions?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_JOKER_BONUS_WIN_Method,
			actions?.joker_bonus_win?.method ?? "post"
		);
		this.set(
			CONFIG_PARAMS.URL_JOKER_BONUS_DISPLAY_METHOD,
			actions?.joker_bonus_display_converted?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_JOKER_BONUS_OPEN_TICKETS_METHOD,
			actions?.list_joker_bonus_open_tickets_v2?.method ?? "get"
		);
		this.set(
			CONFIG_PARAMS.URL_JOKER_BONUS_CURRENCY_CONVERT_METHOD,
			actions?.joker_bonus_converted?.method ?? "get"
		);

		this.set(
			CONFIG_PARAMS.URL_JOKER_BONUS_THEMES_METHOD,
			actions?.joker_bonus_group_theme?.method ?? "get"
		);
	}

	public initResult(initResult: InitResult) {
		this.set(CONFIG_PARAMS.SYMBOL_DEFINITION, initResult.getSymbolDefinition());
		this.set(CONFIG_PARAMS.GAME_SPECIFICS, initResult.getGameSpecifics());
		this.set(CONFIG_PARAMS.FS_GAME_SPECIFICS, initResult.getFSGameSpecifics());
		this.set(CONFIG_PARAMS.START_MATRIX, initResult.getStartMatrix());
		this.set(
			CONFIG_PARAMS.START_SYMBOLS_POSITION,
			initResult.getStartSymbolsPosition()
		);
		this.set(CONFIG_PARAMS.REELS, initResult.getReels());
		this.set(CONFIG_PARAMS.SESSION_ID, initResult.getSessionId());
		this.set(CONFIG_PARAMS.FAIL_RESULT, initResult.getFailResult());
		this.set(CONFIG_PARAMS.WIN_LINES, initResult.getWinLines());
		this.set(CONFIG_PARAMS.PLAYER_ID, initResult.getPlayerId());
		// this.set(CONFIG_PARAMS.BIG_WIN_FACTOR, initResult.getMinBigWinFactor());
		// this.set(CONFIG_PARAMS.MEGA_WIN_FACTOR, initResult.getMinMegaWinFactor());
		// this.set(CONFIG_PARAMS.SUPER_WIN_FACTOR, initResult.getMinSuperMegaWinFactor());
		// this.set(CONFIG_PARAMS.LEGISLATION, initResult.getLegislation());
		// this.set(CONFIG_PARAMS.COINS, initResult.getCoins());
		// this.set(CONFIG_PARAMS.FORCESTOP_ENABLED, initResult.isForcestopEnabled());
		// this.set(CONFIG_PARAMS.BEHAVIOR, initResult.getBehavior());

		if (initResult.getMathVersion()) {
			this.set(CONFIG_PARAMS.MATH_VERSION, initResult.getMathVersion());
		} else if (this.gameconf.get(GAMECONF_PARAMS.MV)) {
			this.set(
				CONFIG_PARAMS.MATH_VERSION,
				this.gameconf.get(GAMECONF_PARAMS.MV)
			);
		} else {
			this.set(CONFIG_PARAMS.MATH_VERSION, "19.43.00");
		}

		console.log(
			`%c MATH VERSION: ${this.get(CONFIG_PARAMS.MATH_VERSION)}`,
			`background: #222; color: #bada55`
		);
	}

	public initReplay(logic: any, round: AddResult) {
		this.set(CONFIG_PARAMS.SYMBOL_DEFINITION, logic?.symbols);
		// this.set(CONFIG_PARAMS.GAME_SPECIFICS, getGameSpec());
		this.set(CONFIG_PARAMS.START_MATRIX, round.getReelMatrix()[0]);
		this.set(CONFIG_PARAMS.CURRENCY, round.getData().round_currency);
		this.set(CONFIG_PARAMS.REELS, logic?.reels);
		this.set(CONFIG_PARAMS.WIN_LINES, logic?.winLines);
	}

	private parseIntParam(name: string, key: string, val: any): null | number {
		if (name === key && val != null) {
			return parseInt(val, 10);
		}

		return val;
	}

	get(key: string): any {
		if (Object.values(CONFIG_PARAMS).indexOf(key) === -1) {
			throw new Error(`Config param ${key} not found!`);
		}

		return this.config[key];
	}

	getMany(...keys: string[]): Record<string, any> {
		const result: Record<string, any> = {}
		keys.forEach((key) => {
			if (Object.values(CONFIG_PARAMS).indexOf(key) === -1) {
				result[key] = null;
				console.warn(`Config param ${key} not found!`)
				return
			}
			result[key] = this.config[key]
		})
		return result
	}

	set(key: string, val: any) {
		if (Object.values(CONFIG_PARAMS).indexOf(key) === -1) {
			throw new Error(`Setting non existing config param ${key} !`);
		}

		this.config[key] = val;
	}

	getGameSpecifics(isBonus = false): undefined | any {
		if (isBonus) {
			return this.get(CONFIG_PARAMS.FS_GAME_SPECIFICS);
		}
		return this.get(CONFIG_PARAMS.GAME_SPECIFICS);
	}

	private initGameConf() {
		this.gameconf = window["__GAME_CONF__"] || {};
		this.gameconf.get = (key): any => {
			if (this.gameconf[key] != null) {
				return this.gameconf[key];
			}
		};
	}
}

export function buildHistoryUrl(url: string, config: SystemConfig): string {
	return `${
		buildUrl(
			url,
			{
				casino_id: config.get(CONFIG_PARAMS.CASINO_ID),
				session_id: config.get(CONFIG_PARAMS.SESSION_ID),
				// language: config.get(CONFIG_PARAMS.LANGUAGE),
			},
			{
				fromgame: true,
			}
		).split("?")[0]
	}?fromgame=true&lang=${config.get(CONFIG_PARAMS.LANGUAGE)}`;
}

export function buildParagraphUrl(
	url: string,
	config: SystemConfig,
	urlOverrides?: Record<string, string>,
	queryParams: Record<string, string> = {
		currency: config.get(CONFIG_PARAMS.CURRENCY),
		player_id: config.get(CONFIG_PARAMS.PLAYER_ID),
		session_id: config.get(CONFIG_PARAMS.SESSION_ID),
	}
) {
	return buildUrl(
		url,
		{
			casino_id: config.get(CONFIG_PARAMS.CASINO_ID),
			game_id: config.get(CONFIG_PARAMS.GAME_ID),
			language: config.get(CONFIG_PARAMS.LANGUAGE),
			...urlOverrides,
		},
		queryParams
	);
}

function buildUrl(url: string, params = {}, getParams = {}): string {
	if (!url) return;

	for (let key in params) {
		url = url.replace(`{${key}}`, params[key]);
	}

	let newUrl;
	try {
		newUrl = new URL(url);
	} catch (e) {
		console.warn(url);
		console.log(e);
		return null;
	}

	for (let key in getParams) {
		newUrl.searchParams.set(key, getParams[key]);
	}

	return newUrl.toString();
}

function decodeUrl(url) {
	if (!url) return url;
	return decodeURIComponent(url);
}
